import { FleekError } from './FleekError';

type PublicKeyAlreadyExistsErrorOptions = {
  publicKey: Record<'publicKey', string>;
};

export class PublicKeyAlreadyExistsError extends FleekError<PublicKeyAlreadyExistsErrorOptions> {
  public name = 'PublicKeyAlreadyExistsError';

  toString = () => `Public key already exists.`;
}
